import ApiConnectorV4 from '@/models/ApiConnectorV4';
import ServiceModel   from '@models/ServiceModel';

const service = window.APP_CONFIG.services.find(service => service.id === 'website');

export const websiteConnector = new ApiConnectorV4({ baseURL: service?.configurations.api_endpoint });

export default class WebsiteServiceModel extends ServiceModel {
	public static get connector() {
		return websiteConnector;
	}

	public get files(): Partial<Record<Website_StonecodeFileTypeReference, ModelFileIncluded[]>> {
		return this.get('@files', {});
	}

	public static serviceName = 'website';
	public static partitionName = 'jts';
}
